import React from 'react'
import { Box, Chip, InputAdornment, TextField, Typography } from '@mui/material'
import { DISTANCE_OPTIONS_MILES, MAX_MILES, MIN_MILES } from '../../utils/drivingArea'

/**
 * How far a driver may go, in miles. Any distance can be typed — the chips are
 * only shortcuts to the common ones, so picking "5" stays a single click while
 * 4.5 or 12 is now possible too.
 *
 * The value is held as typed (a string) so a half-finished "2." doesn't snap
 * back while someone is still typing. drivingAreaPath validates on submit.
 */
export default function DrivingDistanceField({ value, onChange, disabled = false }) {
  const current = parseFloat(value)

  return (
    <Box>
      <TextField
        size="small"
        type="number"
        label="Driving distance"
        value={value}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
        inputProps={{ min: MIN_MILES, max: MAX_MILES, step: 0.5, 'aria-label': 'Driving distance in miles' }}
        InputProps={{ endAdornment: <InputAdornment position="end">mi</InputAdornment> }}
        sx={{ width: 200 }}
      />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1.25 }}>
        {DISTANCE_OPTIONS_MILES.map(d => (
          <Chip
            key={d}
            label={`${d} mi`}
            size="small"
            disabled={disabled}
            onClick={() => onChange(String(d))}
            variant={current === d ? 'filled' : 'outlined'}
            color={current === d ? 'primary' : 'default'}
            sx={{ fontWeight: current === d ? 700 : 400 }}
          />
        ))}
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        Covers everywhere a driver can reach within this distance by road — so an address
        across water, or with no direct route, is left out even when it looks close.
        Anything from {MIN_MILES} to {MAX_MILES} miles.
      </Typography>
    </Box>
  )
}
